export enum BinaryDependencyConfidence {
  Low = 'Low',
  Medium = 'Medium',
  High = 'High',
  Unknown= 'Unknown',
}

/**
 * Convert a number to BinaryDependencyConfidence
 * Assumes that we will only see 25, 50 or 75 - based on CodeSentry results
 */
export function convertToBinaryDependencyConfidence(
  confidence: number,
): BinaryDependencyConfidence {
  if (confidence === 75) {
    return BinaryDependencyConfidence.High;
  }

  if (confidence === 50) {
    return BinaryDependencyConfidence.Medium;
  }

  if (confidence === 25) {
    return BinaryDependencyConfidence.Low;
  }

  return BinaryDependencyConfidence.Unknown;
}
